import clsx from 'clsx'
import React, {
    ReactNode,
    ButtonHTMLAttributes,
} from 'react'
import styles from './Button.module.scss'
import {Spinner} from '../Spinner'
import {AudioManager, AudioType} from '@colonist/audio'

export type ButtonVariant = 'primary' | 'secondary' | 'dark' | 'outline'

export type ButtonProps = {
    variant?: ButtonVariant
    className?: string
    disabled?: boolean
    children?: ReactNode
    onClick?: VoidFunction
    fullWidth?: boolean
    isLoading?: boolean
    loaderClassName?: string
} & ButtonHTMLAttributes<HTMLButtonElement>

export const Button = ({
    className = '',
    variant = 'primary',
    children,
    disabled = false,
    onClick,
    fullWidth,
    isLoading,
    loaderClassName,
    ...props
}: ButtonProps) => (
    <button
        className={clsx(styles.button, {
            [styles.primary]: variant === 'primary',
            [styles.secondary]: variant === 'secondary',
            [styles.dark]: variant === 'dark',
            [styles.outline]: variant === 'outline',
            [styles.disabled]: disabled || isLoading,
            [styles.fullWidth]: fullWidth,
        }, className)}
        disabled={disabled}
        onClick={disabled || isLoading ? undefined : () => {
            AudioManager.play(AudioType.Click)
            onClick?.()
        }}
        {...props}
    >
        {isLoading && <Spinner className={clsx(styles.loader, loaderClassName)} />}
        {children}
    </button>
)
